<div class = "ui-attribute-viewer-icon" *ngIf = "icon">
    <i [class] = "icon"></i>
</div>
<div class = "ui-detail-container">
    @if (invert) {
        <span class = "ui-sub-title">
            {{ subTitle }}
        </span>
        <div class = "ui-title">
            {{ title }}
        </div>
    } @else {
        <div class = "ui-title">
            {{ title }}
        </div>
        <span class = "ui-sub-title">
            {{ subTitle }}
        </span>
    }
    <div class = "ui-label">
        {{ label }}
    </div>
</div>
